export default __webpack_public_path__ + "static/media/4-2_image04@2x.8acacab2.png";